import { makeAutoObservable } from 'mobx';
import { validateFlag } from './validateFlag';

export class FlagData {
  waitUntilCurrentCandleCloses = false;
  candleDuration = 1;
  breakBy = 0;
  pattern = [];

  constructor(initialData) {
    makeAutoObservable(this);
    if (initialData) {
      Object.keys(initialData).forEach(
        (field) => (this[field] = initialData[field])
      );
    }
  }

  //common methods
  resetToDefaults = () => {
    this.waitUntilCurrentCandleCloses = false;
    this.candleDuration = 1;
    this.breakBy = 0;
    this.pattern = [];
  };
  updateTactic = (dataObj) => {
    for (const key in dataObj) {
      this[key] = dataObj[key];
    }
  };
  validate = () => {
    const data = {
      waitUntilCurrentCandleCloses: this.waitUntilCurrentCandleCloses,
      candleDuration: this.candleDuration,
      breakBy: this.breakBy,
      pattern: this.pattern,
    };
    const result = validateFlag(data);
    return result;
  };
  returnJson = () => {
    return {
      waitUntilCurrentCandleCloses: this.waitUntilCurrentCandleCloses,
      candleDuration: this.candleDuration,
      breakBy: this.breakBy,
      pattern: this.pattern,
    };
  };

  //specific methods
  setWaitUntilCurrentCandleCloses = (bool) => {
    this.waitUntilCurrentCandleCloses = bool;
  };
  setCandleDuration = (number) => {
    this.candleDuration = number;
  };
  setBreakBy = (number) => {
    this.breakBy = number;
  };
  setPattern = (pattern) => {
    this.pattern = pattern;
  };
}
